module.exports = __webpack_public_path__ + "static/media/interactive-page-2.353b1609.png";